exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resetpass-success-container{text-align:center}.resetpass-success-container h2{font-size:36px;color:#545454;margin-top:25px;font-weight:400}.resetpass-success-container p{font-size:16px;line-height:1.75;color:#545454;margin-top:15px;text-align:center;margin:5px auto 20px}.resetpass-success-container a.button{width:96%;max-width:350px;display:block;padding:10px 0;border:2px solid #3ec19d;background:#3ec19d;border-radius:2px;text-decoration:none;font-size:16px;color:#fff;text-align:center;font-weight:600;margin:25px auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/home/password_reset_done/password_reset_done.scss
// module id = 572
// module chunks = 0